import { render, staticRenderFns } from "./Preparer.vue?vue&type=template&id=970bf6d8&scoped=true&"
import script from "./Preparer.vue?vue&type=script&lang=js&"
export * from "./Preparer.vue?vue&type=script&lang=js&"
import style0 from "./Preparer.vue?vue&type=style&index=0&id=970bf6d8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "970bf6d8",
  null
  
)

export default component.exports